module.exports = __webpack_public_path__ + "static/media/simple.a0cfd685.png";